import "./instrument";
import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { reactErrorHandler } from "@sentry/react";
// Note: 2026-05-03 audit recommended subset-loading via /latin.css, but
// @fontsource-variable/inter doesn't ship per-subset CSS — variable fonts
// bundle all glyphs in a single file. To trim further (~150KB) we'd need
// custom @font-face with unicode-range, or switch to non-variable
// @fontsource/inter which supports per-subset imports. Deferred.
import "@fontsource-variable/inter";
import App from "./App.tsx";
import "./index.css";

// Lazy-load TrackingScriptLoader so the 101-line module + its supabase
// edge-function call don't ship in the synchronous main bundle. Tracking
// scripts (GTM/GA/etc.) are NOT render-critical — the site works fine
// without them, they fire beacons asynchronously after admin-config fetch.
// Suspense fallback={null} keeps zero visible UI for the brief gap between
// React.lazy resolution and component mount. (Andy 2026-05-08 perf pass.)
const TrackingScriptLoader = lazy(() =>
  import("./components/TrackingScriptLoader").then((m) => ({ default: m.TrackingScriptLoader })),
);

createRoot(document.getElementById("root")!, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.error("[Sentry] Uncaught:", error, errorInfo);
  }),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <Suspense fallback={null}>
      <TrackingScriptLoader />
    </Suspense>
    <App />
  </StrictMode>
);
